export const stylingObject = {
  container: { p: 3 },
  sectionStack: { mt: 1 },
  accordion: {
    '&:before': {
      backgroundColor: 'transparent',
    },
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
  },
  accordionSummary: {
    backgroundColor: '#F4F9FA',
    borderRadius: '8px',
    '&.Mui-expanded': {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
  },
  sectionTitle: { fontWeight: 600, color: '#11567F' },
  search: { maxWidth: 400, mb: 2 },
  emptyState: { py: 4, textAlign: 'center' as const },
  tableHead: { background: '#F4F9FA' },
  tableCell: { paddingY: '12px' },
  statusHeaderCell: { paddingY: '12px', textAlign: 'center' as const, width: '120px' },
  rowTitle: { fontWeight: 500 },
  statusCell: { paddingY: '12px', textAlign: 'center' as const },
} as const;

